// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerTableHandleRowMenuTriggerElement, type TableHandleRowMenuTriggerElement, type TableHandleRowMenuTriggerProps as TableHandleRowMenuTriggerElementProps } from '@prosekit/web/table-handle';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

import { useEditorContext } from '../../contexts/editor-context.ts';

/** Props for the {@link TableHandleRowMenuTrigger} React component. */
export interface TableHandleRowMenuTriggerProps {
  /**
   * @default null
   * @hidden
   */
  editor?: TableHandleRowMenuTriggerElementProps['editor'];
}

function TableHandleRowMenuTriggerComponent(props: TableHandleRowMenuTriggerProps, forwardedRef: ForwardedRef<TableHandleRowMenuTriggerElement>) {
  registerTableHandleRowMenuTriggerElement();

  const elementRef = useRef<TableHandleRowMenuTriggerElement>(null);

  const p0Fallback = useEditorContext();

  const { editor: p0, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    Object.assign(element, { editor: p0 ?? p0Fallback });
  });

  const mergedRef = useCallback(
    (element: TableHandleRowMenuTriggerElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-table-handle-row-menu-trigger', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-table-handle-row-menu-trigger` custom element. */
export const TableHandleRowMenuTrigger: ForwardRefExoticComponent<TableHandleRowMenuTriggerProps & HTMLAttributes<TableHandleRowMenuTriggerElement> & RefAttributes<TableHandleRowMenuTriggerElement>> = /* @__PURE__ */ forwardRef(TableHandleRowMenuTriggerComponent);
